import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../stylesheets/messageBox.css';
import crossImg from './cross.svg';
import { FormattedMessage } from 'react-intl';
export default class MessageBox extends Component {
  constructor(props) {
    super(props);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleConfirm(event) {
    event.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  }

  handleCancel(event) {
    event.preventDefault();
    if (this.props.onCancel) {
      this.props.onCancel();
    } else if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleClose(event) {
    event.preventDefault();
    if (this.props.onClose) {
      this.props.onClose();
    } else if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  render() {
    const titleColor = {
      background: this.props.titleColor || '#4C97E3',
    };
    const {
      confirmText,
      cancelText,
    } = this.props;

    return (
      <div className="message-box-container">
        <div
          className="message-box"
          style={{
            width: this.props.width ? this.props.width : 250,
          }}
        >
          <h2 className="message-box-title" style={titleColor}>
            {this.props.title}
            <button className="message-box-close-button pull-right"
              style={{ color: this.props.titleColor || '#4C97E3', background: 'transparent' }}
              onClick={this.handleClose}
            >
              <img src={crossImg} width="20px" height="20px"/>
            </button>
          </h2>
          <div className="message-box-body">
            {this.props.message && this.props.message}
            {this.props.children && (this.props.children)}
          </div>
          <div className="message-box-actions clearfix" style={{ textAlign: 'center' }}>
            <button className="btn btn-primary"
              onClick={this.handleConfirm}
              style={{
                background: this.props.titleColor || '#4C97E3',
              }}
            >
              { confirmText ? confirmText : <FormattedMessage id="SH_Confirm" defaultMessage="確定"/> }
            </button>
            {
              this.props.onCancel &&
              <button className="btn btn-secondary"
                onClick={this.handleCancel}
                style={{
                  marginLeft: 10,
                }}
              >
                { cancelText ? cancelText : <FormattedMessage id="SH_Cancel" defaultMessage="取消"/> }
              </button>
            }
          </div>
        </div>
      </div>
    );
  }
}

MessageBox.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  titleColor: PropTypes.string,
  onClose: PropTypes.func,
  width: PropTypes.number,
  children: PropTypes.object,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/MessageBox.js
 **/